import React, { useContext, useEffect, useRef, useState } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { InputTextarea } from "primereact/inputtextarea";
import { InputNumber } from "primereact/inputnumber";
import { confirmDialog } from "primereact/confirmdialog";
import { Checkbox } from "primereact/checkbox";

// ------------------ COMPONENTES DE BASE--------------------------
import Loader from "../../../Base/Components/Loader/Loader";
import Card from "../../../Base/Components/Card/Card";
import AgGrid from "../../../Base/Components/Tables/AgGrid/AgGrid";
import { useForm } from "../../../Base/Hooks/useForm";
import { AuthContext } from "../../../Base/Context/AuthContext/AuthContext";
import AutoCompleteDropdown from "../../../Base/Components/Form/AutoCompleteDropdown";
import { toastShow } from "../../../Base/Services/ToastService";
import { getDateTimeStringSQL } from "../../../Base/Services/Moment/Luxon";

// ------------------- CONSULTAS A LA API---------------------------
import { ObtenerCurrency } from "../../../Base/API/Global/Currency/CurrencyRequest";
import { getTasaCambio } from "../../../API/CalendarioOperativo/CalendarioOperativoRequest";
import { getRangosDocumentosPorID } from "../../../API/Finanzas/RegistroContable/RangosDocumentosRequest";
import { getProveedorAct } from "../../../API/Compras/Proveedores/ProveedoresRequest";
import { getCuentasHijas } from "../../../API/Finanzas/Retencion/ConceptoRetencionRequest";
import ProductosOverlayPanel from "../../ERP/Compras/Requisas/CrudRequisa/OverlayPanels/ProductoOverlayPanel";
import { AnularBoletaCompra, EditarBoleta, eliminarDetallesBoleta, EntregarBoletaCompra, getBoletaCompraPorDetID, getBoletaCompraPorEncID, GuardarBoleta } from "../../../API/Finanzas/CajaChica/BoletaCompraRequest";
import BoletaCompraReporte from "./BoletaCompraReporte";

const BoletaCompraCRUD = ({
  showDialog,
  setShowDialog,
  selectedEnc,
  setSelectedEnc,
  getInfo,
  habilitar,
  setHabilitar,
}) => {
  const { userAuth } = useContext(AuthContext);
  const toast = useRef(null);
  const toast2 = useRef(null);

  const [detalles, setDetalles] = useState([]);
  const [selected, setSelected] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [proveedores, setProveedores] = useState([]);
  const [monedas, setMonedas] = useState([]);
  const [cuentas, setCuentas] = useState([]);
  const [showDialogAnular, setShowDialogAnular] = useState(false);
  const [showDialogReporte, setShowDialogReporte] = useState(false);

  const initialValues = {
    IdBoletaCompraEnc: -1,
    Comentario: '',
    OrdenCompra: '',
    RegistroSAG: '',
    ConstanciaRegistro:'',
    FechaCreate: new Date()
  };

  const { values, setValues, handleInputChange, handleChange, resetForm } = useForm(initialValues);

  const getValoresIniciales = async () => {
    setLoading(true);
    setSelected([]);
    const rangosTempo = await getRangosDocumentosPorID(41);
    const currencyTempo = await ObtenerCurrency()
    setMonedas(currencyTempo.filter(i => i?.IdCurrency !== 3))

    const proveedoresTempo = await getProveedorAct()
    setProveedores(proveedoresTempo)

    const tasaTempo = await getTasaCambio()

    const tempoCuentas = await getCuentasHijas()
    setCuentas(tempoCuentas)


    if (selectedEnc?.length > 0) {
      setHabilitar(false);
      let IdBoletaCompraEnc = selectedEnc[0]?.IdBoletaCompraEnc
      if(IdBoletaCompraEnc){
        const encabezadoTempo = await getBoletaCompraPorEncID(IdBoletaCompraEnc)
        const detallesTempo = await getBoletaCompraPorDetID(IdBoletaCompraEnc)
        setValues({
          ...encabezadoTempo[0],
          FechaEmision: new Date(encabezadoTempo[0]?.FechaEmision)
        })
        setDetalles(detallesTempo)

      }else{
        toastShow(toast, 'warn', 'Advertencia', 'No se encontro la boleta de compra')
      }
    } else {
      const { Prefijo, RangoInicial, Count, IdRango } = rangosTempo[0];
      const numero = RangoInicial + Count;
      const numeroFormateado = String(numero).padStart(8, "0");
      const NumeroBoletaCompra = `${Prefijo}-${numeroFormateado}`;
      let RangoBoleta = `${Prefijo}-0000`
      setValues({
        ...initialValues,
        NumeroBoletaCompra: NumeroBoletaCompra,
        IdRangoBoletaCompra: IdRango,
        RangoBoleta: RangoBoleta,
        TasaCambio: tasaTempo[0]?.TasaCambio,
      });
      setDetalles([]);
    }

    setLoading(false);
  };

  const getNuevoRegistro = async () => {
    const rangosTempo = await getRangosDocumentosPorID(41);
    const tasaTempo = await getTasaCambio()
    const { Prefijo, RangoInicial, Count, IdRango } = rangosTempo[0];
    const numero = RangoInicial + Count;
    const numeroFormateado = String(numero).padStart(8, "0");
    const NumeroBoletaCompra = `${Prefijo}-${numeroFormateado}`;
    let RangoBoleta = `${Prefijo}-0000`
    setValues({
      ...initialValues,
      NumeroBoletaCompra: NumeroBoletaCompra,
      IdRangoBoletaCompra: IdRango,
      RangoBoleta: RangoBoleta,
      TasaCambio: tasaTempo[0]?.TasaCambio,
    });
    setDetalles([]);
  };

  const verificarCampos = () => {
    let err = false;

    if (!values?.CustomerName && !values?.IdVendor) {
      err = true;
      toastShow(toast, "error", "Error", "Proveedor es requerido.");
      return;
    }
    if (!values?.Currency && !values?.IdCurrency) {
      err = true;
      toastShow(toast, "error", "Error", "Moneda es requerida.");
      return;
    }
    if (!values?.FechaEmision) {
      err = true;
      toastShow(toast, "error", "Error", "La fecha de emisión es requerida.");
      return;
    }
    if (!values?.NombreCuenta && !values?.IdCuenta) {
      err = true;
      toastShow(toast, "error", "Error", "Cuenta es requerida.");
      return;
    }
    if (!values?.Comentario) {
      err = true;
      toastShow(toast, "error", "Error", "Comentario es requerido.");
      return;
    }


    if (detalles.length > 0) {
      detalles.forEach((i) => {
        if (!i.IdProduct && !i.Descripcion) {
          toastShow(toast,"error","Error","Debe agregar un producto o una descripción en todos los detalles");
          err = true;
          return;
        }
        if (!i.Unidades && i.Unidades === 0) {
          toastShow(toast,"error","Error","Ingrese unidades válidas en los detalles");
          err = true;
          return;
        }
        if (!i.Precio && i.Precio === 0) {
          toastShow(toast,"error","Error","Ingrese un precio válido en los detalles");
          err = true;
          return;
        }
      });
    }

    return !err;
  };

  const guardarBoleta = async () => {
    if (verificarCampos()) {
      let TasaCambio = values?.TasaCambio
      let IdCurrency = values?.Currency?.IdCurrency || values?.IdCurrency
    
      const encabezado = {
        IdBoletaCompraEnc: values?.IdBoletaCompraEnc,
        NumeroBoletaCompra: values?.NumeroBoletaCompra,
        IdProveedor: values?.CustomerName?.IdVendor || values?.IdProveedor,
        IdCurrency: values?.Currency?.IdCurrency || values?.IdCurrency,
        IdRangoBoletaCompra: values?.IdRangoBoletaCompra,
        TasaCambio: values?.TasaCambio,
        FechaEmision: getDateTimeStringSQL(new Date(values.FechaEmision)),
        OrdenCompra: values?.OrdenCompra,
        ConstanciaRegistro: values?.ConstanciaRegistro,
        RegistroSAG: values?.RegistroSAG,
        IdCuenta: values?.NombreCuenta.IdAccount || values?.IdCuenta,
        Comentario: values?.Comentario,
        IdUserCreate: userAuth?.IdUser,
        IdUserEdit: userAuth?.IdUser,
        Total: detalles.reduce((acc, i) => acc + (parseFloat(i?.Total) || 0), 0),
        TotalL: IdCurrency === 1 ? detalles.reduce((acc, i) => acc + (parseFloat(i?.Total) || 0), 0) * TasaCambio : detalles.reduce((acc, i) => acc + (parseFloat(i?.Total) || 0), 0),
        TotalD: IdCurrency === 1 ? detalles.reduce((acc, i) => acc + (parseFloat(i?.Total) || 0), 0) : detalles.reduce((acc, i) => acc + (parseFloat(i?.Total) || 0), 0) / TasaCambio,
      }

      const listDetalles = detalles.map((det) => ({
        IdBoletaCompraDet: det?.IdBoletaCompraDet,
        IdProduct: det?.IdProduct,
        Descripcion: det.Descripcion,
        Unidades: det?.Unidades,
        Precio: det?.Precio,
        PrecioL: IdCurrency === 1 ? det.Precio * TasaCambio : det.Precio,
        PrecioD: IdCurrency === 1 ? det.Precio : det.Precio / TasaCambio,
        Monto: det?.Monto,
        MontoL: IdCurrency === 1 ? det?.Monto * TasaCambio : det?.Monto,
        MontoD: IdCurrency === 1 ? det.Precio : det.Precio / TasaCambio,
        SubTotal: det?.SubTotal,
        SubTotalL: IdCurrency === 1 ? det?.SubTotal * TasaCambio : det?.SubTotal,
        SubTotalD: IdCurrency === 1 ? det.SubTotal : det.SubTotal / TasaCambio,
        Total: det?.Total,
        TotalL: IdCurrency === 1 ? det?.Total * TasaCambio : det?.Total,
        TotalD: IdCurrency === 1 ? det.Total : det.Total / TasaCambio,
        IdUserCreate: userAuth?.IdUser,
        IdUserEdit: userAuth?.IdUser,
      }))

      setLoading(true)
      if(encabezado?.IdBoletaCompraEnc > 0){
        const resp = await EditarBoleta(encabezado, listDetalles);
        if(resp[0]?.ESTADO === 1){
          toastShow(toast, "success", "Editada", resp[0]?.MENSAJE);
          setTimeout(() => {
            setLoading(false)
            setShowDialog(false);
            getInfo()
            setSelectedEnc([])
          }, 1800);
        }else{
          toastShow(toast, "error", "Error", 'Error al guardar la información.');
        }
      }else{
        const resp = await GuardarBoleta(encabezado, listDetalles);
        if(resp[0]?.ESTADO === 1){
          toastShow(toast, "success", "Guardada", resp[0]?.MENSAJE);
          setTimeout(() => {
            setLoading(false)
            setShowDialog(false);
            getInfo()
            setSelectedEnc([])
          }, 1800);
        }else{
          toastShow(toast, "error", "Error", 'Error al guardar la información.');
        }
      }
    }
  };

  const agregarNuevaFila = () => {
    let newRowData = [...detalles];

    let IdDet = -(detalles?.length +  1)
    const newData = {
      IdBoletaCompraDet: IdDet,
      FechaCreate: new Date(),
      IdProduct: null,
      NombreProducto: '',
      Descripcion: '',
      Unidades: 0,
      Precio: 0,
      Monto: 0,
      SubTotal: 0,
      Total: 0,
    };
    newRowData.push(newData);
    setDetalles(newRowData);
  };

  const EliminarDetalle = async () => {
    if (selected.some((item) => item.IdBoletaCompraDet > 0)) {
      confirmDialog({
        message: "¿Está seguro que desea eliminar el detalle?",
        header: "Confirmación",
        icon: "pi pi-exclamation-triangle",
        accept: async () => {
          setLoading(true);
          const nuevosDetalles = detalles.filter(detalle => !selected.some(item => item.IdBoletaCompraDet === detalle.IdBoletaCompraDet));
          const Ids = selected.filter(item => item.IdBoletaCompraDet > 0).map(item => item.IdBoletaCompraDet).join(',');
          const resp = await eliminarDetallesBoleta(Ids);
          toastShow(toast, "success", "Eliminado", 'Detalles eliminados correctamente');
          setTimeout(() => {
            setLoading(false);
            setDetalles(nuevosDetalles);
            setSelected([]);
          }, 600);
        },
        reject: () => {},
      });
    } else {
      const idsAEliminar = selected.map((item) => item.IdBoletaCompraDet);
      const nuevosDetalles = detalles.filter(
        (detalle) => !idsAEliminar.includes(detalle.IdBoletaCompraDet)
      );
      setDetalles(nuevosDetalles);
      setSelected([]);
    }
  };

  const AnularBoleta = async () => {
    let err
    if (!values?.ComentarioAnulado) {
      err = true;
      toastShow(toast2, "error", "Error", "Ingrese un comentario de anulación.");
      return;
    }
    if(!err){
      setLoading2(true);
      let Datos = {
        IdBoletaCompraEnc: values?.IdBoletaCompraEnc,
        IdUserAutoriza: userAuth?.IdUser,
        ComentarioAnulado: values?.ComentarioAnulado,
      }

      const resp = await AnularBoletaCompra(Datos)
      toastShow(toast2, 'success', 'Anulada', 'Boleta de compra anulada correctamente')
      setTimeout(() => {
        setShowDialogAnular(false)
        setLoading2(false)
        getValoresIniciales()
      }, 1000);
    }
  };

  const changeProducto = ({ data }) => {
    return (
      <ProductosOverlayPanel
        rowData={data}
        onChange={({ api, data }, rowData) => {
          const index = detalles.findIndex((detail) =>detail.IdBoletaCompraDet ===rowData.IdBoletaCompraDet);
          const encuentra = detalles.find(i => i?.IdProduct === data.IdProduct)
          if(encuentra){
            toastShow(toast, 'error', 'Error', 'El producto seleccionada ya esta agregado en esta boleta de compra.')
            return
          }

          let newDetail = [...detalles];
          newDetail[index].IdProduct = data.IdProduct;
          newDetail[index].CodigoProducto = data.CodigoProducto;
          newDetail[index].NombreProducto = data.NombreProducto;
          // newDetail[index].DescripcionProducto = data.DescripcionProducto;
          setDetalles(newDetail);
          api.stopEditing();

        }}
      />
    );
  };

  const entregarBoleta = async () => {
    confirmDialog({
      message: "¿Está seguro que desea entregar la boleta de compra?",
      header: "Confirmación",
      icon: "pi pi-exclamation-triangle",
      accept: async () => {
        setLoading(true);
        let Datos = {
          IdBoletaCompraEnc: values?.IdBoletaCompraEnc,
          IdUserEdit: userAuth?.IdUser,
        }

        const resp = await EntregarBoletaCompra(Datos)
        toastShow(toast, 'success', 'Editada', 'Boleta de compra entregada correctamente')
        setTimeout(() => {
          setLoading(false)
          getValoresIniciales()
        }, 1000);
      },
      reject: () => {},
    });
  }

  const columns = [
    {
      field: "IdBoletaCompraDet",
      header: "ID",
      headerEn: "ID",
      hidden: userAuth.IdRol === 1,
      className: "XXsmall",
      frozen: 1,
    },
    {
      header: "Código",
      headerEn: "Code",
      field: "CodigoProducto",
      className: "Xsmall",
      cellEditor: changeProducto,
      editable: habilitar,
    },
    {
      header: "Producto",
      headerEn: "Product",
      field: "NombreProducto",
      className: "XXXlarge",
    },
    {
      field: "Descripcion",
      header: "Descripción",
      headerEn: 'Description',
      flex:1,
      minWith: 250,
      editable: habilitar,
    },
    {
      field: "Unidades",
      header: "Unidades",
      headerEn: "Units",
      className: "Xsmall",
      editable: habilitar,
      Format: "Currency",
      Sumary: "sum",
      onChange: (data) => {
        if (data.newValue) {
          let det = data.data;
          det.Unidades = data.newValue;
          det.Monto = data.newValue * det.Precio;
          det.SubTotal = data.newValue * det.Precio;
          det.Total = data.newValue * det.Precio;
          let tempo = [...detalles];
          const index = tempo.findIndex((d) => d.IdBoletaCompraDet === det.IdBoletaCompraDet);
          tempo[index] = det;
          setDetalles(tempo);
        }
      },
    },
    {
      field: "Precio",
      header: "Precio",
      headerEn: "Price",
      editable: habilitar,
      className: "Xsmall",
      Format: "Currency",
      onChange: (data) => {
        if (data.newValue) {
          let det = data.data;
          det.Precio = data.newValue;
          det.Monto = data.newValue * det.Unidades;
          det.SubTotal = data.newValue * det.Unidades;
          det.Total = data.newValue * det.Unidades;
          let tempo = [...detalles];
          const index = tempo.findIndex((d) => d.IdBoletaCompraDet === det.IdBoletaCompraDet);
          tempo[index] = det;
          setDetalles(tempo);
        }
      },
    },
    {
      field: "Monto",
      header: "Monto",
      headerEn: "Mount",
      className: "small",
      Format: "Currency",
      Sumary: "sum",
    },
    {
      field: "SubTotal",
      header: "SubTotal",
      className: "small",
      Format: "Currency",
      Sumary: "sum",
    },
    {
      field: "Total",
      header: "Total",
      className: "small",
      Format: "Currency",
      Sumary: "sum",
    },
  ];

  const table = {
    Columns: columns,
    Data: detalles,
    selected: selected,
    setSelected: setSelected,
    showModal: (e) => {},
  };

  useEffect(() => {
    getValoresIniciales(selectedEnc);
  }, [selectedEnc]);

  const cerrarDialog = () => {
    if (habilitar) {
      confirmDialog({
        message: "¿Está seguro que desea salir sin guardar?",
        header: "Confirmación",
        icon: "pi pi-exclamation-triangle",
        accept: () => {
          setShowDialog(false);
          setSelectedEnc([]);
          resetForm();
          setDetalles([]);
          setHabilitar(true);
          getInfo()
        },
        reject: () => {},
      });
    } else {
      setShowDialog(false);
      setSelectedEnc([]);
      setHabilitar(true);
      getInfo()
    }
  };

  const DialogFooter = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={() => setShowDialogAnular(false)}
      />
      <Button
        label={'Aceptar'}
        icon="pi pi-check"
        className="p-button-text"
        onClick={AnularBoleta}
      />
    </React.Fragment>
  );

  return (
    <Dialog
      visible={showDialog}
      onHide={() => cerrarDialog()}
      header={"Boleta de Compra"}
      style={{ width: "90vw", height: "100vh" }}
      maximizable
    >
      <div id="Dialog">
        <Loader loading={loading} querySelector={'#Dialog'}/>
        <Toast ref={toast} />
        
        {/* ENCABEZADO */}
        <div className="d-flex flex-column">
          <Card
            contenido={
              <div className="d-flex">
                <div className="col-12">
                  {/* ------------------------- CAMPOS ----------------------- */}
                  <div className="d-flex flex-wrap align-items-start gap-2 mt-2">

                    <span className=" field p-float-label">
                      <InputText
                        id="NumeroBoletaCompra"
                        name="NumeroBoletaCompra"
                        value={values?.NumeroBoletaCompra}
                        onChange={handleInputChange}
                        style={{ fontWeight: "bold" }}
                        disabled
                      />
                      <label htmlFor="NumeroBoletaCompra">No. Boleta</label>
                    </span>

                    <div style={{width: 380}}>
                      <AutoCompleteDropdown
                        enable={habilitar}
                        value={values?.CustomerName}
                        items={proveedores}
                        field={"CustomerName"}
                        name={"CustomerName"}
                        handleInputChange={handleInputChange}
                        label={"Proveedor"}
                      />
                    </div>

                    <span className=" field p-float-label">
                      <InputText
                        id="RangoBoleta"
                        name="RangoBoleta"
                        value={values?.RangoBoleta}
                        onChange={handleInputChange}
                        disabled
                      />
                      <label htmlFor="RangoBoleta">Rango Boleta</label>
                    </span>

                    <AutoCompleteDropdown
                      enable={habilitar}
                      value={values?.Currency}
                      items={monedas}
                      field={"Currency"}
                      name={"Currency"}
                      handleInputChange={handleInputChange}
                      label={"Moneda"}
                    />

                    <span className=" field p-float-label">
                      <InputNumber
                        disabled={!habilitar}
                        minFractionDigits={2}
                        maxFractionDigits={2}
                        useGrouping={true}
                        id="TasaCambio"
                        name="TasaCambio"
                        style={{ width: "261px" }}
                        value={values?.TasaCambio}
                        onChange={handleInputChange}
                      />
                      <label htmlFor="TasaCambio">Tasa de Cambio</label>
                    </span>

                    <span className="p-float-label">
                      <Calendar
                        id="FechaEmision"
                        name="FechaEmision"
                        disabled={!habilitar}
                        onChange={(e) =>handleInputChange(e, "FechaEmision")}
                        value={values?.FechaEmision}
                        dateFormat="dd/mm/yy"
                        mask="99/99/9999"
                        showIcon
                        style={{height: 45}}
                      />
                      <label htmlFor="FechaEmision">Fecha Emisión</label>
                    </span>

                    <span className=" p-float-label d-flex">
                      <InputText
                        disabled={!habilitar}
                        id="OrdenCompra"
                        name="OrdenCompra"
                        value={values?.OrdenCompra}
                        onChange={handleInputChange}
                        style={{width: 400}}
                      />
                      <label htmlFor="OrdenCompra">OrdenCompra</label>
                    </span>

                    <span className=" p-float-label d-flex">
                      <InputText
                        disabled={!habilitar}
                        id="ConstanciaRegistro"
                        name="ConstanciaRegistro"
                        value={values?.ConstanciaRegistro}
                        onChange={handleInputChange}
                        style={{width: 400}}
                      />
                      <label htmlFor="ConstanciaRegistro">Constancia Registro Exónerado</label>
                    </span>

                    <span className=" p-float-label d-flex">
                      <InputText
                        disabled={!habilitar}
                        id="RegistroSAG"
                        name="RegistroSAG"
                        value={values?.RegistroSAG}
                        onChange={handleInputChange}
                        style={{width: 400}}
                      />
                      <label htmlFor="RegistroSAG">Registro SAG</label>
                    </span>

                    <div style={{ width: "26%" }}>
                      <AutoCompleteDropdown
                        enable={habilitar}
                        value={values?.NombreCuenta}
                        items={cuentas}
                        field={"NombreCuenta"}
                        name={"NombreCuenta"}
                        handleInputChange={handleInputChange}
                        label={"Cuenta Débito"}
                      />
                    </div>

                    <span className=" p-float-label d-flex">
                      <InputTextarea
                        disabled={!habilitar}
                        id="Comentario"
                        name="Comentario"
                        value={values?.Comentario}
                        onChange={handleInputChange}
                        cols={83}
                        style={{ height: "3rem" }}
                      />
                      <label htmlFor="Comentario">Comentario</label>
                    </span>
                  </div>

                  {/* --------------------------BOTONES-----------------------  */}
                  <div className="d-flex flex-wrap gap-2 mb-2 mt-3">
                    <Button
                      icon="pi pi-plus"
                      type="button"
                      onClick={() => agregarNuevaFila()}
                      tooltip="Editar"
                      tooltipOptions={{ position: "top" }}
                      disabled={!habilitar}
                    />

                    {values?.IdStatus === 115 && (
                      <Button
                        icon="pi pi-pencil"
                        type="button"
                        onClick={() => setHabilitar(true)}
                        tooltip="Editar"
                        tooltipOptions={{ position: "top" }}
                      />
                    )}

                    <Button
                      icon="pi pi-save"
                      type="button"
                      onClick={guardarBoleta}
                      tooltip="Guardar"
                      tooltipOptions={{ position: "top" }}
                      disabled={!habilitar || detalles?.length === 0}
                    />

                    <Button
                      icon="pi pi-times"
                      type="button"
                      className="p-button-danger"
                      onClick={() => EliminarDetalle()}
                      tooltip="Eliminar"
                      disabled={!habilitar || selected?.length === 0}
                      tooltipOptions={{ position: "top" }}
                    />

                    <Button
                      icon="pi pi-sync"
                      type="button"
                      onClick={() => getValoresIniciales()}
                      tooltip="Cargar"
                      tooltipOptions={{ position: "top" }}
                    />


                    {values?.IdBoletaCompraEnc > 0 && (
                      <Button
                        icon="pi pi-print"
                        onClick={() => setShowDialogReporte(true)}
                        tooltip="Reporte"
                        tooltipOptions={{ position: "top" }}
                      />
                    )}

                    <Button
                      icon="pi pi-book"
                      type="button"
                      onClick={() => {
                        confirmDialog({
                          message: "¿Está seguro que desea crear nueva boleta?",
                          header: "Crear Nueva Boleta",
                          icon: "pi pi-exclamation-triangle",
                          accept: () => {
                            getNuevoRegistro();
                          },
                        });
                      }}
                      tooltip="Nueva Boleta"
                      tooltipOptions={{ position: "top" }}
                    />

                    {values?.IdBoletaCompraEnc > 0 && (
                      <Button
                        icon="ri-file-close-line"
                        label="Anular Boleta"
                        type="button"
                        disabled={!habilitar}
                        onClick={() => setShowDialogAnular(true)}
                        tooltip="Cargar"
                        tooltipOptions={{ position: "top" }}
                      />
                    )}

                    <div
                      style={{
                        backgroundColor: values.Background || '#f9b8b8',
                        color: values.Color || '#a81a1a',
                        padding: "14px",
                        borderRadius: "6px",
                        textAlign: "center",
                        fontWeight: "bold",
                        width:'8%',
                        fontSize:12
                      }}
                    >
                      {values.StatusName || 'Pendiente de entrega'}
                    </div>

                    {values?.IdStatus === 119 && (
                      <span className="p-float-label d-flex">
                        <InputText
                          disabled={!habilitar}
                          id="ComentarioAnulado"
                          name="ComentarioAnulado"
                          value={values?.ComentarioAnulado}
                          onChange={handleInputChange}
                          style={{width: 400}}
                        />
                        <label htmlFor="ComentarioAnulado">Comentario anulación</label>
                      </span>
                    )}

                    {values?.IdBoletaCompraEnc > 0 && (
                      <div className="mt-2">
                        <span className="mx-2 mt-4">Entregar</span>
                        <Checkbox
                          id="Entregado"
                          disabled={!habilitar && (userAuth?.IdRol !== 1 || userAuth?.IdRol !== 36)}
                          name="Entregado"
                          checked={values.IdStatus === 118}
                          onChange={(e) => entregarBoleta()}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            }
          />
        </div>

        {/* DETALLES */}
        <Card
          contenido={
            <div style={{ height: "52vh" }}>
              <AgGrid table={table} />
            </div>
          }
        />
        
        <div className="mt-2" style={{ textAlign: "right", marginRight: 10 }}>
          <p style={{ marginBottom: "1px", fontSize: 14}}>
            <strong>Usuario Creación:</strong> {values?.UserNameCreate ? values?.UserNameCreate : userAuth?.UserName}
          </p>
          <p style={{ marginBottom: "1px", fontSize: 14 }}>
            <strong>Fecha Creación:</strong> {values?.FechaCreateStr}
          </p>
          {values?.UserNameEdit && (
            <p style={{ marginBottom: "1px", fontSize: 14 }}>
              <strong>Usuario Edición:</strong> {values?.UserNameEdit}
            </p>
          )}
          {values?.FechaEditStr && (
            <p style={{ marginBottom: "1px", fontSize: 14 }}>
              <strong>Fecha Edición:</strong> {values.FechaEditStr}
            </p>
          )}
        </div>

        {showDialogAnular && (
          <Dialog
            visible={showDialogAnular}
            onHide={() => setShowDialogAnular(false)}
            header={'Anular Boleta'}
            style={{ width: "20vw", height: "20vh" }}
            footer={DialogFooter}
          >
            <Toast ref={toast2} />
            <Loader loading={loading2} querySelector={'#Dialog2'}/>
            <div id='Dialog2'>
              <p style={{ marginBottom: "1px", fontSize: 14}}>
                <strong>¿Está seguro que desea anular la boleta de compra?</strong>
              </p>
              <span className=" p-float-label d-flex mt-2">
                <InputText
                  id="ComentarioAnulado"
                  name="ComentarioAnulado"
                  value={values?.ComentarioAnulado}
                  onChange={handleInputChange}
                  style={{width: 400}}
                />
                <label htmlFor="ComentarioAnulado">Comentario Anulado</label>
              </span>
            </div>
          </Dialog>
        )}


        {showDialogReporte && (
          <BoletaCompraReporte
            showDialogReporte={showDialogReporte}
            setShowDialogReporte={setShowDialogReporte}
            selected={values}
            setSelected={() => {}}
          />
        )}
      </div>
    </Dialog>
  );
};

export default BoletaCompraCRUD;
